import React, { Component } from "react";
import { GET_RC_EXCEL_LIST, LOGIN_TYPE_ADMIN } from "./helper/Constants";
import Apihelpers from "./helper/ApiHelper";
import $ from 'jquery';
import { DateRangePicker, Dropdown, Alert } from 'rsuite';
import { NavLink } from "react-router-dom";
import { reactLocalStorage } from "reactjs-localstorage";
const moment = require('moment-timezone');
const FileDownload = require('js-file-download');


class ReportList extends Component {

  constructor(props) {
    super(props);
    this.state = {
      rcexcelDownloadData: [],
      isloading: true
    };
  }

  componentDidMount() {

    Apihelpers.getdataresponse('rcexcel-list/getreportlist').then(res => {
        console.log("response data----->",res.data)
      if (res.data.status === true) {
        this.setState({
          rcexcelDownloadData: res.data.data,
          isloading: false
        });
      }
      else {
        this.setState({
          rcexcelDownloadData: res.data.data,
          isloading: false
        });
      }
    });

    $(document).ready(function(){
      $(".apiHitList").on('click','.showMore',function(){
        console.log('click');
        var moreVal = $(this).parents('tr').next('tr').find('.moreVal');
        if (moreVal.is(':visible')) {
          moreVal.css('display','none');
        } else {
          $(".apiHitList").find('.moreVal').css('display','none');
          moreVal.css('display','table-cell');
        }
      });
    })
  }


  downloadRCFileResponse = async (download_urls) => {
    //console.log(download_urls)
    var folder = "export-report/";
    if (download_urls.length > 0) {
      this.setState({isloading: true});
      for(const it of download_urls) {
        await Apihelpers.downloadFileresponse(folder + it).then(res => {
          //console.log('res.data',res.data);
          FileDownload(res.data, it);
        }).catch((err) => {
          console.log(err);
        });
      }
      //loading hide
      this.setState({isloading: false});
    }
  }


  render() {
    const {
      beforeToday,
    } = DateRangePicker;
    return (
      <React.Fragment>
        <div className="wrapper">
          <header className="header">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-auto" style={{ width: "93%" }}>
                  <div className="logo">
                    <a><img src="/assets/images/logo.png" alt="" /></a>
                  </div>
                </div>
                <div style={{ float: "right" }}>
                  <NavLink
                    className="blueBtn btn-sm"
                    to={"/admin/logout"}
                    exact
                    activeClassName="active"
                    style={{ padding: " 5px 10px", fontSize: "12px" }}
                  > LOGOUT
                      </NavLink>
                </div>
              </div>
            </div>
          </header>
          
          <div className="container">
            <div className="noteTextrcexcelList"> Note: You have to wait at least 30 min to complete processing. And After Seven days Download request will be removed.</div>
              <div className="table-responsive bulk-rc-uploaded-file-list apiHitList">
              <table className="table">
                <tbody>
                  <tr>
                    <th>Date</th>
                    {reactLocalStorage.get("login_type") == LOGIN_TYPE_ADMIN?<th>Input Time</th>:""}
                    {reactLocalStorage.get("login_type") == LOGIN_TYPE_ADMIN?<th>Output Time</th>:""}
                    <th>Output</th>
                    <th style={{width:'125px'}}>Download</th>
                    <th>Input</th>
                  </tr>
                  {this.state.rcexcelDownloadData.length > 0 ?
                    this.state.rcexcelDownloadData.map((singlercexcelDownloadData, index) => {
                      var gmtDateTime = moment.utc(singlercexcelDownloadData.created_at, "YYYY-MM-DD HH:mm:ss")
                      var gmtDateTimeProcessStart = moment.utc(singlercexcelDownloadData.process_start_at, "YYYY-MM-DD HH:mm:ss")
                      var gmtDateTimeProcessEnd = moment.utc(singlercexcelDownloadData.process_end_at, "YYYY-MM-DD HH:mm:ss")
                      var localIST = gmtDateTime.utcOffset('+05:30').format('DD-MM-YYYY HH:mm:ss')
                      var localISTProcessStart = gmtDateTimeProcessStart.utcOffset('+05:30').format('DD-MM-YYYY HH:mm:ss')
                      var localISTProcessEnd = gmtDateTimeProcessEnd.utcOffset('+05:30').format('DD-MM-YYYY HH:mm:ss')
                      if (localISTProcessStart === "Invalid date" && localISTProcessEnd === "Invalid date") {
                        localISTProcessStart = "Not Process Yet"
                        localISTProcessEnd = "Not Process Yet"
                     }
                      return (
                        <React.Fragment key={index}>
                        <tr>
                          <td>{localIST}</td>
                          {reactLocalStorage.get("login_type") == LOGIN_TYPE_ADMIN ? <td>{localISTProcessStart}</td> : null}
                          {reactLocalStorage.get("login_type") == LOGIN_TYPE_ADMIN ? <td>{localISTProcessEnd}</td> : null}
                          <td>
                            {
                              singlercexcelDownloadData.outPutResponseFile.length > 0 ?  singlercexcelDownloadData.outPutResponseFile.map((it, i)=> {
                                return (<span key={i}>{i !== 0 ? ', '+it : it}</span>)
                              })
                              : '-'
                            }
                          </td>
                          <td>
                            {singlercexcelDownloadData.processing_status === "completed" ?
                              <button className="yellowBtn" onClick={() => this.downloadRCFileResponse(singlercexcelDownloadData.outPutResponseFile)}>Download</button> : <button className="process" disabled={"disabled"} >Processing</button>}
                          </td>
                          <td><span className="showMore"></span></td>
                        </tr>
                        <tr>
                          <td className="moreVal" colSpan="6">
                            {reactLocalStorage.get("login_type") == LOGIN_TYPE_ADMIN ? <pre className="preTag">{JSON.stringify(JSON.parse(singlercexcelDownloadData.inputfile),null,2)}</pre> : null}
                          </td>
                      </tr>
                      </React.Fragment>
                      )
                    })
                    :
                    <tr>
                      <td colSpan="7" align="center">
                        <img src="/assets/images/data-not-found-img.png" width="150" /><br /><br />
                        <b style={{ fontSize: 12 }}>No Data Found</b>
                      </td>
                    </tr>
                  }

                </tbody>
              </table>
              </div>
              
              {this.state.isloading == false ?
              ""
              :
              <div className="loader" style={{ display: "block" }}>
                <div className="bg"></div>
                <img className="loadingImg" src="/assets/images/loading.gif" alt="" />
              </div>
            }
          </div>
        </div>
      </React.Fragment>
    )
  }
}

export default ReportList;
